// src/services/organizationsService.js
import { apiRequest } from './api';

export const organizationsService = {
    // Get organizations list (simple list without pagination)
    getOrganizationsList: async () => {
        try {
            const response = await apiRequest.get('/organizations/list');
            return response.data.data;
        } catch (error) {
            throw new Error(error.message || 'Failed to fetch organizations list');
        }
    },

    // Get single organization
    getOrganization: async (orgId) => {
        try {
            const response = await apiRequest.get(`/organizations/${orgId}`);
            return response.data.data;
        } catch (error) {
            throw new Error(error.message || 'Failed to fetch organization');
        }
    }
};
